import { InfoIcon, UserSettingsIcon, VibrateIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';

interface RouteSettings {
    title: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    path: string;
    value: string;
}

export const dataSettingsRoutes: RouteSettings[] = [
    {
        title: 'Личные данные',
        icon: UserSettingsIcon,
        path: routesApp.profileEdit,
        value: 'Личные данные',
    },
    {
        title: 'Правила использования сервиса',
        icon: InfoIcon,
        path: routesApp.termsOfService,
        value: 'Правила использования сервиса',
    }
];
